require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-divisare-featuring-armadale-residence.json") })
        }
      }, "path---journal-divisare-featuring-armadale-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-divisare-featuring-armadale-residence!./.cache/json/journal-divisare-featuring-armadale-residence.json
// module id = 480
// module chunks = 231608221292675